export enum PublicObservableSections {
  SET_CATEGORY = 'set-category',
  SHOW_MODAL = 'show-modal',
  SET_AGES = 'set-ages',
}
